const H = "-", L = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, g = 35, f = Math.floor, w = String.fromCharCode;
function l(e) {
  throw new RangeError(L[e]);
}
function A(e) {
  const t = [];
  let s = 0;
  const r = e.length;
  for (; s < r; ) {
    const h = e.charCodeAt(s++);
    if (h >= 55296 && h <= 56319 && s < r) {
      const a = e.charCodeAt(s++);
      (a & 64512) == 56320 ? t.push(((h & 1023) << 10) + (a & 1023) + 65536) : (t.push(h), s--);
    } else
      t.push(h);
  }
  return t;
}
const E = (e) => e >= 48 && e < 58 ? 26 + (e - 48) : e >= 65 && e < 91 ? e - 65 : e >= 97 && e < 123 ? e - 97 : 36, U = (e, t) => e + 22 + 75 * (e < 26 ? 1 : 0) - 0, y = (e, t, s) => {
  let r = 0;
  for (
    e = s ? f(e / 700) : e >> 1, e += f(e / t);
    /* no initialization */
    e > g * 26 >> 1;
    r += 36
  )
    e = f(e / g);
  return f(r + (g + 1) * e / (e + 38));
}, x = (e) => {
  const t = [], s = e.length;
  let r = 0, h = 128, a = 72, i = e.lastIndexOf(H);
  i < 0 && (i = 0);
  for (let n = 0; n < i; ++n)
    e.charCodeAt(n) >= 128 && l("not-basic"), t.push(e.charCodeAt(n));
  for (let n = i > 0 ? i + 1 : 0; n < s; ) {
    const p = r;
    for (let m = 1, c = 36; ; c += 36) {
      n >= s && l("invalid-input");
      const _ = E(e.charCodeAt(n++));
      _ >= 36 && l("invalid-input"), _ > f((2147483647 - r) / m) && l("overflow"), r += _ * m;
      const u = c <= a ? 1 : c >= a + 26 ? 26 : c - a;
      if (_ < u)
        break;
      const d = 36 - u;
      m > f(2147483647 / d) && l("overflow"), m *= d;
    }
    const o = t.length + 1;
    a = y(r - p, o, p == 0), f(r / o) > 2147483647 - h && l("overflow"), h += f(r / o), r %= o, t.splice(r++, 0, h);
  }
  return String.fromCodePoint(...t);
}, v = (e) => {
  const t = [], s = A(e), r = s.length;
  let h = 128, a = 0, i = 72;
  for (const o of s)
    o < 128 && t.push(w(o));
  const n = t.length;
  let p = n;
  for (n && t.push(H); p < r; ) {
    let o = 2147483647;
    for (const c of s)
      c >= h && c < o && (o = c);
    const m = p + 1;
    o - h > f((2147483647 - a) / m) && l("overflow"), a += (o - h) * m, h = o;
    for (const c of s)
      if (c < h && ++a > 2147483647 && l("overflow"), c === h) {
        let _ = a;
        for (let u = 36; ; u += 36) {
          const d = u <= i ? 1 : u >= i + 26 ? 26 : u - i;
          if (_ < d)
            break;
          const $ = _ - d, S = 36 - d;
          t.push(w(U(d + $ % S))), _ = f($ / S);
        }
        t.push(w(U(_))), i = y(a, m, p === n), a = 0, ++p;
      }
    ++a, ++h;
  }
  return t.join("");
}, R = /^:/, O = /^\[.*\]$/;
function I(e) {
  return R.test(e) || O.test(e);
}
function P(e) {
  return e.split("/").filter(I);
}
function b(e) {
  return e.slice(1, R.test(e) ? void 0 : -1);
}
function C(e, t) {
  return P(e).reduce((s, r) => {
    const h = b(r);
    return t[h] ? s.replace(r, t[h]) : s;
  }, e);
}
function T(e, t) {
  return P(e).reduce((s, r) => {
    const h = b(r), {
      [h]: a,
      ...i
    } = s;
    return i;
  }, t);
}
const N = 127;
function j(e) {
  return e.charCodeAt(0) > N;
}
class M {
  constructor(t) {
    if (this._href = "", this._protocol = "", this._host = "", this._hostname = "", this._port = "", this._pathname = "", this._search = "", this._hash = "", this._origin = "", this._username = "", this._password = "", this._baseUrl = "", this._searchParams = new URLSearchParams(), this.punycodePrefix = "xn--", this._searchParams = new URLSearchParams(), typeof t == "string" || t instanceof URL)
      this.href = t.toString();
    else if (t) {
      if (t.baseUrl && (this.baseUrl = t.baseUrl), t.href && (this.href = t.href), t.protocol && (this.protocol = t.protocol), t.host && (this.host = t.host), t.hostname && (this.hostname = t.hostname), t.port && (this.port = t.port), t.pathname && (this.pathname = C(t.pathname, t.query ?? {})), t.search && (this.search = t.search), t.hash && (this.hash = t.hash), t.username && (this.username = t.username), t.password && (this.password = t.password), t.query) {
        const s = T(t.pathname ?? "", t.query);
        Object.keys(s).length > 0 && (this.search = new URLSearchParams(s).toString());
      }
      this.updateHref();
    }
  }
  static create(t) {
    return new M(t);
  }
  static canParse(t) {
    if (t.startsWith("/"))
      return /^\/[^?#]*(\?[^#]*)?(#.*)?$/.test(t);
    try {
      return new URL(t), !0;
    } catch {
      return /^[^:/?#]+(\.[^:/?#]+)+(\/[^?#]*(\?[^#]*)?(#.*)?)?$/.test(t);
    }
  }
  get baseUrl() {
    return this._baseUrl;
  }
  set baseUrl(t) {
    this._baseUrl = t;
    try {
      const s = new URL(t);
      this._protocol = s.protocol, this._host = s.host, this._hostname = s.hostname, this._port = s.port, this._origin = s.origin, this._username = s.username, this._password = s.password, s.pathname !== "/" && (this._pathname = s.pathname), s.search && (this._search = s.search, this._searchParams = new URLSearchParams(s.search)), s.hash && (this._hash = s.hash), this.updateHref();
    } catch (s) {
      console.warn(`Invalid baseUrl: ${t}`, s);
    }
  }
  get href() {
    return this.pathname.length === 1 ? `${this._href}/` : this._href;
  }
  set href(t) {
    try {
      const s = new URL(t);
      this._href = s.href, this._protocol = s.protocol, this._host = s.host, this._hostname = s.hostname, this._port = s.port, this._pathname = s.pathname, this._search = s.search, this._hash = s.hash, this._origin = s.origin, this._username = s.username, this._password = s.password, this._searchParams = s.searchParams;
    } catch (s) {
      console.warn(`Can not parse ${t}`, s);
    }
  }
  get protocol() {
    return this._protocol;
  }
  set protocol(t) {
    this._protocol = t, this.updateHref();
  }
  get host() {
    return this._host;
  }
  set host(t) {
    const [s, r] = t.split(":"), h = this.encodeHostname(s);
    this._host = r ? `${h}:${r}` : h, this._hostname = h, this._port = r || "", this.updateHref();
  }
  get hostname() {
    return this._hostname;
  }
  set hostname(t) {
    const s = this.encodeHostname(t);
    this._hostname = s, this._host = this._port ? `${s}:${this._port}` : s, this.updateHref();
  }
  get port() {
    return this._port;
  }
  set port(t) {
    this._port = t, this._host = `${this._hostname}${t ? ":" + t : ""}`, this.updateHref();
  }
  get pathname() {
    return this._pathname;
  }
  set pathname(t) {
    const s = t.split("/").map((r) => I(r) ? r : encodeURI(r)).join("/");
    this._pathname = s.startsWith("/") ? s : `/${s}`, this.updateHref();
  }
  get search() {
    return this._search;
  }
  set search(t) {
    this._search = t.startsWith("?") ? t : `?${t}`, this._searchParams = new URLSearchParams(t), this.updateHref();
  }
  setSearchParams(t) {
    const s = new URLSearchParams(t);
    this._search = s.toString() ? `?${s.toString()}` : "", this._searchParams = s, this.updateHref();
  }
  appendSearchParams(t) {
    const s = new URLSearchParams(this._searchParams), r = P(this._pathname).map(b);
    Object.keys(t).forEach((h) => {
      r.includes(h) ? this._pathname = C(this._pathname, {
        [h]: t[h]
      }) : s.append(h, t[h]);
    }), this._search = s.toString() ? `?${s.toString()}` : "", this._searchParams = s, this.updateHref();
  }
  removeSearchParams(...t) {
    const s = new URLSearchParams(this._searchParams);
    t.forEach((r) => {
      s.delete(r);
    }), this._search = s.toString() ? `?${s.toString()}` : "", this._searchParams = s, this.updateHref();
  }
  get searchParams() {
    return new Proxy(this._searchParams, {
      get: (t, s, r) => {
        const h = Reflect.get(t, s, r);
        return typeof h == "function" ? (...a) => {
          const i = h.apply(t, a);
          return this._search = this._searchParams.toString() ? `?${this._searchParams.toString()}` : "", this.updateHref(), i;
        } : h;
      }
    });
  }
  get hash() {
    return this._hash;
  }
  set hash(t) {
    this._hash = t.startsWith("#") ? t : `#${t}`, this.updateHref();
  }
  get origin() {
    return this._origin;
  }
  get username() {
    return this._username;
  }
  set username(t) {
    this._username = t, this.updateHref();
  }
  get password() {
    return this._password;
  }
  set password(t) {
    this._password = t, this.updateHref();
  }
  updateHref() {
    if (this._baseUrl) {
      const t = new URL(this._baseUrl);
      t.pathname = this._pathname, t.search = this._search, t.hash = this._hash, this._href = t.href, this._origin = t.origin;
    } else
      this._href = `${this._protocol}${this._protocol && "//"}${this._username}${this._password ? ":" + this._password : ""}${this._username || this._password ? "@" : ""}${this._hostname}${this._port ? ":" + this._port : ""}${this._pathname === "/" ? "" : this._pathname}${this._search}${this._hash}`, this._origin = `${this._protocol}//${this._hostname}${this._port ? ":" + this._port : ""}`;
  }
  toString() {
    return this.href;
  }
  toJSON() {
    return this.href;
  }
  encodeHostname(t) {
    return t.split(".").map((s) => {
      for (const r of s)
        if (j(r))
          return `${this.punycodePrefix}${v(s)}`;
      return s;
    }).join(".");
  }
  get decodedIDN() {
    let t = this._href;
    return this._hostname.split(".").forEach((s) => {
      t = t.replace(s, x(s.replace(this.punycodePrefix, "")));
    }), t;
  }
  get decodedHostname() {
    return this._hostname.split(".").map((t) => x(t.replace(this.punycodePrefix, ""))).join(".");
  }
}
export {
  M as default
};
//# sourceMappingURL=index.mjs.map
